/* RESPONSIBLE TEAM: team-knowledge-foundations */

let currentOverlay: HTMLElement | null = null;

function findBlockContainer(): Element | null {
  return document.querySelector('.ProseMirror') ?? document.querySelector('.intercom-interblocks');
}

function findBlockAtIndex(container: Element, index: number): HTMLElement | undefined {
  let element = container.children[index] as HTMLElement | undefined;
  if (element?.classList.contains('ProseMirror-gapcursor')) {
    element = container.children[index + 1] as HTMLElement | undefined;
  }
  return element;
}

export function removeBlockHighlight(): void {
  if (currentOverlay) {
    currentOverlay.remove();
    currentOverlay = null;
  }
}

function createHighlightOverlay(
  blockElement: HTMLElement,
  positionedParent: HTMLElement,
): HTMLElement {
  let parentRect = positionedParent.getBoundingClientRect();
  let blockRect = blockElement.getBoundingClientRect();

  let overlay = document.createElement('div');
  overlay.className = 'content-readiness-block-highlight';
  overlay.style.top = `${blockRect.top - parentRect.top}px`;
  overlay.style.left = `${blockRect.left - parentRect.left}px`;
  overlay.style.width = `${blockRect.width}px`;
  overlay.style.height = `${blockRect.height}px`;

  return overlay;
}

export function scrollToAndHighlightBlock(blockIndex: number): void {
  removeBlockHighlight();

  let blockContainer = findBlockContainer();
  if (!blockContainer) {
    return;
  }

  let blockElement = findBlockAtIndex(blockContainer, blockIndex);
  if (!blockElement) {
    return;
  }

  let scrollingContainer = document.getElementById('content-readiness-scrolling-container');
  if (!scrollingContainer) {
    return;
  }

  let positionedParent = scrollingContainer.firstElementChild as HTMLElement | null;
  if (!positionedParent) {
    return;
  }

  let containerRect = scrollingContainer.getBoundingClientRect();
  let elementRect = blockElement.getBoundingClientRect();
  let containerPadding = 65;
  let visibleAreaCenter = (containerRect.height - containerPadding) / 2 - containerPadding;
  let scrollTop =
    scrollingContainer.scrollTop + elementRect.top - containerRect.top - visibleAreaCenter;
  let maxScrollTop = scrollingContainer.scrollHeight - scrollingContainer.clientHeight;
  let clampedScrollTop = Math.max(0, Math.min(scrollTop, maxScrollTop));

  scrollingContainer.scrollTo({ top: clampedScrollTop, behavior: 'smooth' });

  let overlay = createHighlightOverlay(blockElement, positionedParent);
  positionedParent.appendChild(overlay);
  currentOverlay = overlay;
}
